import axios from 'axios';
import { userApi } from "../../../config";

// DMIT Test booking function
export const bookDmitTestSession = async (bookingPayload: any) => {
    debugger
    try {
        // API endpoint change karke "/book-dmit-test" kiya gaya hai
        const res = await userApi.post("/book-dmit-test", bookingPayload, { 
            headers: { 
                Authorization: `Bearer ${sessionStorage.getItem("userAccessToken")}` 
            }  
        });
        return res.data;
    } catch (err: any) {
        // Error handling same rakhi gayi hai
        return { 
            success: false, 
            message: err.response?.data?.message || "Booking failed." 
        };
    }
};

// DMIT Test payment verification function
export const verifyDmitTestPayment = async (paymentPayload: any) => {
    try {
        // API endpoint change karke "/verify-dmit-test-payment" kiya gaya hai
        const res = await userApi.post("/verify-dmit-test-payment", paymentPayload, { 
            headers: { 
                Authorization: `Bearer ${sessionStorage.getItem("userAccessToken") || null}` 
            } 
        });
        return res.data;
    } catch (err: any) {
        return { 
            success: false, 
            message: err.response?.data?.message || "Payment verification failed." 
        };
    }
};